import React from 'react';
import { graphql, type HeadProps } from 'gatsby';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import SEO from '../components/Storyblok/SEO';
import { useStoryblokSSG } from '../hooks';
import { PageData, PageSEO } from '../types';

type PrivacyPolicyPageProps = {
  data: PageData;
};

const PrivacyPolicy = ({ data = {} }: PrivacyPolicyPageProps) => {
  const { storyToRender } = useStoryblokSSG(data.storyblokEntry ?? null, { slug: 'privacy-policy' });

  return <div className="h-full">{storyToRender?.content && <StoryblokComponent blok={storyToRender.content} />}</div>;
};

export default PrivacyPolicy;

export const query = graphql`
  query PrivacyPolicyPageQuery {
    storyblokEntry(slug: { eq: "privacy-policy" }) {
      id
      internalId
      content
      name
      full_slug
    }
  }
`;

export function Head({ location, data = {} }: HeadProps<PageData>) {
  if (!data.storyblokEntry) return null;

  const content = JSON.parse(data.storyblokEntry.content) as PageSEO;
  const metaData = {
    title: content.metaDataTitle,
    description: content.metaDataDescription,
    image: content.metaDataImage?.filename,
    imageTwitter: content.metaDataImageTwitter?.filename,
    imageAltText: content?.metaDataImageAltText,
    location,
    fbDomainVerification: content.metaDataFbDomainVerification,
  };

  // @ts-expect-error SEO component is not typed
  return <SEO {...metaData} />;
}
